const productsData = [
  {
    id: 'patrocinio-gold',
    title: 'Patrocinio Gold Punto de Fe',
    product: 'Presencia de marca en set',
    investment: '$200 USD / mes',
    impacts: [
      'Menciones, rotativa audiovisual y presencia de marca en set con Margarita.',
      'El Rincón del Diario: Margarita utiliza libretas y fineliner Artesco para la "Palabra del Día".',
      'Vitrina viva de productos que valida la calidad ante una audiencia que busca orden y paz.',
    ],
  },
  {
    id: 'trazos-esperanza',
    title: 'Segmento "Trazos de Esperanza"',
    product: 'Espacio editorial de marca',
    investment: '$125 USD / mes',
    impacts: [
      'Micro-meditación donde Margarita realiza trazos, subraya textos sagrados o colorea mandalas de fe.',
      'Demostración de uso de productos premium con la línea de arte de Artesco.',
      'Marketing sensorial en vivo.',
    ],
  },
  {
    id: 'tno-digest',
    title: 'Estrategia TNO Digest',
    product: 'Sección "Mente Creativa"',
    investment: '$100 USD / mes',
    impacts: [
      'Artículos semanales firmados por Margarita sobre el dibujo y la escritura creativa.',
      'Vinculan a Artesco con bienestar, reducción de ansiedad y conexión espiritual.',
      'Autoridad de contenido que humaniza la marca.',
    ],
  },
  {
    id: 'multiplataforma',
    title: 'Campaña Multiplataforma',
    product: 'Reels + On-Demand',
    investment: '$75 USD / mes',
    impacts: [
      'Masterclass en Reels: "3 pasos para crear tu Mapa de Fe con Artesco".',
      'Videos cortos de alta estética grabados en el TNO Media Lab para redes de TNO y Margarita.',
      'Contenido On-Demand disponible para siempre, conectando con nuevos usuarios cada día.',
    ],
  },
];

export default productsData;
